import { Provider } from "./provider/Provider";

const YazilarService = {
  yaziListesi: ({ baslangic, limit, lang }) => {
    return Provider({
      baslangic,
      limit,
      lang,
      methodName: "Module/Yazilar/YaziListesi"
    });
  },
  yaziDetay: ({ yaziCode, lang }) => {
    return Provider({
      yaziCode,
      lang,
      methodName: "Module/Yazilar/YaziDetay"
    });
  },
  yaziEkle: ({ baslik, icerik, link, thumbnail, kategoriler, seoIcerik, publish, tags, fields, lang }) => {
    return Provider({
      baslik,
      icerik,
      link,
      thumbnail,
      kategoriler,
      seoIcerik,
      publish,
      tags,
      fields,
      lang,
      methodName: "Module/Yazilar/YaziEkle"
    });
  },
  yaziyiGuncelle: ({ yaziCode, baslik, icerik, link, thumbnail, kategoriler, seoIcerik, publish, tags, fields, lang }) => {
    return Provider({
      yaziCode,
      baslik,
      icerik,
      link,
      thumbnail,
      kategoriler,
      seoIcerik,
      publish,
      tags,
      fields,
      lang,
      methodName: "Module/Yazilar/YaziyiGuncelle"
    });
  },
  yayinaAl: ({ yaziCode }) => {
    return Provider({
      yaziCode,
      methodName: "Module/Yazilar/YayinaAl"
    });
  },
  taslakOlarakKaydet: ({ yaziCode }) => {
    return Provider({
      yaziCode,
      methodName: "Module/Yazilar/TaslakOlarakKaydet"
    });
  },
  yaziyiKaldir: ({ yaziCode }) => {
    return Provider({
      yaziCode,
      methodName: "Module/Yazilar/YaziyiKaldir"
    });
  },
  topluYayinaAl: ({ yaziCodes }) => {
    return Provider({
      yaziCodes,
      methodName: "Module/Yazilar/TopluYayinaAl"
    });
  },
  topluTaslakOlarakKaydet: ({ yaziCodes }) => {
    return Provider({
      yaziCodes,
      methodName: "Module/Yazilar/TopluTaslakOlarakKaydet"
    });
  },
  topluOlarakKaldir: ({ yaziCodes }) => {
    return Provider({
      yaziCodes,
      methodName: "Module/Yazilar/TopluOlarakKaldir"
    });
  },
  yaziAra: ({ ara, baslangic, limit }) => {
    return Provider({
      ara,
      baslangic,
      limit,
      methodName: "Module/Yazilar/YaziAra"
    });
  },
  kategoriEkle: ({ kategoriAdi, kategoriAciklamasi, kategoriEbeveyni }) => {
    return Provider({
      kategoriAdi,
      kategoriAciklamasi,
      kategoriEbeveyni,
      methodName: "Module/Yazilar/KategoriEkle"
    });
  },
  kategoriGuncelle: ({ kategoriCode, kategoriAdi, kategoriAciklamasi, kategoriEbeveyni }) => {
    return Provider({
      kategoriCode,
      kategoriAdi,
      kategoriAciklamasi,
      kategoriEbeveyni,
      methodName: "Module/Yazilar/KategoriGuncelle"
    });
  },
  kategoriKaldir: ({ kategoriCode }) => {
    return Provider({
      kategoriCode,
      methodName: "Module/Yazilar/KategoriKaldir"
    });
  },
  kategoriDetay: ({ kategoriCode }) => {
    return Provider({
      kategoriCode,
      methodName: "Module/Yazilar/KategoriDetay"
    });
  },
  kategoriListesi: () => {
    return Provider({
      methodName: "Module/Yazilar/KategoriListesi"
    });
  }
};

export default YazilarService;
